module.exports = __webpack_public_path__ + "img/pay-alipay.680b0014.svg";